import { useLocation, useNavigate } from "react-router-dom";
import useAuthentication from "../../../hooks/useAuthentication";
import { useForm } from "react-hook-form";
import {
  initialFormData,
  MasterFormDataType,
  MasterTableDataType,
} from "./types";
import usePopup from "../../../hooks/usePopup";
import { useMutation, useQuery } from "react-query";
import { saveMasterData } from "./services";
import { ChangeEvent, useEffect, useState } from "react";
import {
  Paper,
  Typography,
  Button,
  CircularProgress,
  Divider,
} from "@mui/material";
import { CustomFormField } from "../../../utilis/component/CustomFormElement";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { getAllAccountCategories } from "../AccountCategory/services";

const pageTitle = "Account tag ";
function AddOrEditAccountTag() {
  const { user } = useAuthentication();
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState<string>("");
  const { control, handleSubmit, reset } = useForm<MasterFormDataType>({
    defaultValues: initialFormData,
  });

  const {
    state: { data = null },
  } = useLocation() as { state: { data: MasterTableDataType } };

  const { showSnackbar } = usePopup();
  const handleGoBack = () => {
    navigate(-1);
  };



   const {data:accountTag,isLoading:categoryLoading} = useQuery(["categoryforaccounttype",searchText],async ()=> await getAllAccountCategories({
      filter:{searchText,status:1},
      pageNumber:0,
      pageSize:250,
      sortField:"",
      sortOrder:""
    }),{refetchOnWindowFocus:false})

  const { mutate: save, isLoading } = useMutation(saveMasterData, {
    onSuccess: (result) => {
      if (result.responseIndicator == "success") {
        showSnackbar({
          message: result.responseMessage,
          open: true,
          variant: "success",
          duration: 3000,
        });
        handleGoBack();
      } else {
        showSnackbar({
          message: result.responseMessage,
          open: true,
          variant: "warning",
          duration: 3000,
        });
      }
    },
    onError: (e: any) => {
      showSnackbar({
        message:
          e?.response?.data?.responseMessage ||
          e?.response?.data?.errorMessage ||
          "Something went wrong !",
        open: true,
        variant: "error",
        duration: 3000,
      });
    },
  });

  const onSubmit = (value: MasterFormDataType) => {
    save([
      {
        ...value,
        categoryId: Number(value.category?.categoryId),
        createdByUserId: Number(user?.groupId || 0),
        tagClinicId: Number(user?.clinicId || 0),
        tagStatus: Number(value.tagStatus),
        tagId: data?.tagId || 0,
      },
    ]);
  };

  const handleReset = () => {
    reset(initialFormData);
  };

  const handleSearchCategory = (e:ChangeEvent<HTMLInputElement>)=>{
    setSearchText(e.target.value)
  }

  useEffect(() => {
    console.log("accountTag------->", accountTag);
  }, [accountTag]);

  useEffect(() => {
    if (data) {
      reset({
        ...data,
        category: {
          categoryId: data.categoryId,
          categoryName: data.categoryName,
        },
      });
    }
  }, [data]);

  return (
    <div className="p-3">
      <form onSubmit={handleSubmit(onSubmit)}>
        <Paper>
          <div className="flex justify-between items-center p-2">
            <div>
              <Typography variant="h6" className="p-3">
                {data ? "Update" : "Add"} {pageTitle}
              </Typography>
            </div>
            <div className="flex gap-2">
              <Button
                disabled={isLoading}
                variant="outlined"
                startIcon={<ArrowBackIcon />}
                onClick={handleGoBack}
              >
                back
              </Button>
              {!Boolean(data) && (
                <Button
                  disabled={isLoading}
                  color="error"
                  type="reset"
                  onClick={handleReset}
                  startIcon={<CloseIcon />}
                >
                  reset
                </Button>
              )}
              <Button
                disabled={isLoading}
                type="submit"
                color="success"
                startIcon={
                  isLoading ? (
                    <CircularProgress size={20} color="success" />
                  ) : (
                    <SaveIcon />
                  )
                }
              >
                {data ? "update" : "save"}
              </Button>
            </div>
          </div>
          <Divider />
          <div className="p-3 grid grid-cols-4 gap-3">
            <CustomFormField
              control={control}
              name="tagCode"
              element="input"
              fieldProps={{ label: "Enter tag code " }}
              rules={{ required: "Code is required" }}
            />
            <CustomFormField
              control={control}
              name="tagName"
              element="input"
              fieldProps={{ label: "Enter tag name " }}
              rules={{ required: "Code is required" }}
            />
            <CustomFormField
              control={control}
              name="category"
              element="autocomplete"
              loading={categoryLoading}
              options={accountTag?.response.categoryResponseDto || []}
              autocompleteProps={{
                getOptionLabel: (option) => option.categoryName,
                isOptionEqualToValue: (option, value) =>
                  option.categoryId == value.categoryId,
              }}
              fieldProps={{ label: "Select category ",onChange:handleSearchCategory }}
              rules={{ required: "Category is required" }}
            />
            <CustomFormField
              control={control}
              name="tagStatus"
              element="radio"
              radioProps={{ row: true }}
              radios={[
                { label: "Active", value: 1 },
                { label: "Inactive", value: 0 },
              ]}
              fieldProps={{ label: "Status " }}
              rules={{ required: "Status is required" }}
            />
          </div>
        </Paper>
      </form>
    </div>
  );
}

export default AddOrEditAccountTag;
